export const seoConfig = {
  'zh-CN': {
    title: 'Focus Zone - 专注工作学习 | 白噪音冥想放松应用',
    description: '专业的专注力提升工具，配备白噪音、自然音效和舒缓背景。帮助您专心工作、高效学习、冥想放松。内含励志名言，让专注更有动力。',
    keywords: '专注工具,白噪音,专注力训练,工作专注,学习专注,冥想放松,番茄工作法,效率工具,背景音乐,自然音效,专注应用,放松音乐,深度工作,心理健康',
    ogTitle: 'Focus Zone - 专注工作学习的最佳伴侣',
    ogDescription: '专业的专注力提升工具，白噪音与自然音效助您专心工作学习，配以励志名言激发动力。',
    twitterTitle: 'Focus Zone - 专注力提升工具',
    twitterDescription: '白噪音 + 自然音效 + 励志名言 = 完美专注体验 🎯',
    lang: 'zh-CN',
    hreflang: 'zh',
    locale: 'zh_CN'
  },
  'en-US': {
    title: 'Focus Zone - Concentration & Study Tool | White Noise & Meditation',
    description: 'Professional focus enhancement tool with white noise, nature sounds, and calming backgrounds. Boost productivity, improve concentration for work and study, with meditation support and inspirational quotes.',
    keywords: 'focus tool,white noise,concentration,productivity,study focus,meditation,work focus,ambient sounds,background music,nature sounds,focus app,relaxation,deep work,mindfulness,pomodoro technique',
    ogTitle: 'Focus Zone - Your Ultimate Concentration Companion',
    ogDescription: 'Professional focus enhancement tool with white noise and nature sounds to boost productivity and concentration.',
    twitterTitle: 'Focus Zone - Concentration Tool',
    twitterDescription: 'White noise + Nature sounds + Inspirational quotes = Perfect focus experience 🎯',
    lang: 'en-US',
    hreflang: 'en',
    locale: 'en_US'
  },
  'ja-JP': {
    title: 'Focus Zone - 集中力向上アプリ | ホワイトノイズ・瞑想・リラックス',
    description: '仕事・勉強の集中力を高める専用ツール。ホワイトノイズ、自然音、リラックス背景で生産性向上。瞑想機能と励ましの言葉で集中をサポート。',
    keywords: '集中力,ホワイトノイズ,集中アプリ,勉強集中,仕事効率,瞑想,リラックス,自然音,環境音,集中力向上,生産性,深い作業,マインドフルネス,ポモドーロテクニック',
    ogTitle: 'Focus Zone - 集中力向上の究極ツール',
    ogDescription: 'ホワイトノイズと自然音で仕事・勉強の集中力を高める専用アプリ。',
    twitterTitle: 'Focus Zone - 集中力アプリ',
    twitterDescription: 'ホワイトノイズ + 自然音 + 励ましの言葉 = 完璧な集中体験 🎯',
    lang: 'ja-JP',
    hreflang: 'ja',
    locale: 'ja_JP'
  },
  'es-ES': {
    title: 'Focus Zone - Herramienta de Concentración | Ruido Blanco y Meditación',
    description: 'Herramienta profesional para mejorar la concentración con ruido blanco, sonidos naturales y fondos relajantes. Aumenta la productividad en trabajo y estudio, con soporte de meditación.',
    keywords: 'herramienta concentración,ruido blanco,concentración,productividad,enfoque estudio,meditación,enfoque trabajo,sonidos ambiente,música fondo,sonidos naturaleza,app concentración,relajación,trabajo profundo',
    ogTitle: 'Focus Zone - Tu Compañero de Concentración Definitivo',
    ogDescription: 'Herramienta profesional con ruido blanco y sonidos naturales para mejorar la concentración y productividad.',
    twitterTitle: 'Focus Zone - Herramienta Concentración',
    twitterDescription: 'Ruido blanco + Sonidos naturales + Frases inspiradoras = Experiencia perfecta de concentración 🎯',
    lang: 'es-ES',
    hreflang: 'es',
    locale: 'es_ES'
  },
  'fr-FR': {
    title: 'Focus Zone - Outil de Concentration | Bruit Blanc et Méditation',
    description: 'Outil professionnel d\'amélioration de la concentration avec bruit blanc, sons naturels et arrière-plans apaisants. Boostez la productivité au travail et dans les études.',
    keywords: 'outil concentration,bruit blanc,concentration,productivité,focus étude,méditation,focus travail,sons ambiants,musique fond,sons nature,app concentration,relaxation,travail profond,pleine conscience',
    ogTitle: 'Focus Zone - Votre Compagnon de Concentration Ultime',
    ogDescription: 'Outil professionnel avec bruit blanc et sons naturels pour améliorer la concentration et la productivité.',
    twitterTitle: 'Focus Zone - Outil Concentration',
    twitterDescription: 'Bruit blanc + Sons naturels + Citations inspirantes = Expérience de concentration parfaite 🎯',
    lang: 'fr-FR',
    hreflang: 'fr',
    locale: 'fr_FR'
  },
  'de-DE': {
    title: 'Focus Zone - Konzentrations-Tool | Weißes Rauschen und Meditation',
    description: 'Professionelles Konzentrations-Verbesserungstool mit weißem Rauschen, Naturgeräuschen und beruhigenden Hintergründen. Steigern Sie Produktivität bei Arbeit und Studium.',
    keywords: 'konzentrations tool,weißes rauschen,konzentration,produktivität,lern fokus,meditation,arbeits fokus,umgebungsgeräusche,hintergrundmusik,naturgeräusche,konzentrations app,entspannung,deep work',
    ogTitle: 'Focus Zone - Ihr Ultimativer Konzentrations-Begleiter',
    ogDescription: 'Professionelles Tool mit weißem Rauschen und Naturgeräuschen zur Verbesserung von Konzentration und Produktivität.',
    twitterTitle: 'Focus Zone - Konzentrations-Tool',
    twitterDescription: 'Weißes Rauschen + Naturgeräusche + Inspirierende Zitate = Perfekte Konzentrationserfahrung 🎯',
    lang: 'de-DE',
    hreflang: 'de',
    locale: 'de_DE'
  },
  'ko-KR': {
    title: 'Focus Zone - 집중력 향상 도구 | 백색소음과 명상 앱',
    description: '백색소음, 자연음, 편안한 배경으로 집중력을 향상시키는 전문 도구. 업무와 학습 생산성을 높이고, 명상과 휴식을 지원합니다.',
    keywords: '집중력 도구,백색소음,집중력,생산성,학습 집중,명상,업무 집중,환경음,배경음악,자연음,집중 앱,휴식,딥워크,마음챙김,뽀모도로 기법',
    ogTitle: 'Focus Zone - 궁극의 집중력 향상 도구',
    ogDescription: '백색소음과 자연음으로 업무와 학습의 집중력을 향상시키는 전문 앱.',
    twitterTitle: 'Focus Zone - 집중력 앱',
    twitterDescription: '백색소음 + 자연음 + 영감 명언 = 완벽한 집중 경험 🎯',
    lang: 'ko-KR',
    hreflang: 'ko',
    locale: 'ko_KR'
  },
  'pt-BR': {
    title: 'Focus Zone - Ferramenta de Concentração | Ruído Branco e Meditação',
    description: 'Ferramenta profissional para melhorar a concentração com ruído branco, sons naturais e fundos relaxantes. Aumente a produtividade no trabalho e estudos.',
    keywords: 'ferramenta concentração,ruído branco,concentração,produtividade,foco estudo,meditação,foco trabalho,sons ambiente,música fundo,sons natureza,app concentração,relaxamento,trabalho profundo',
    ogTitle: 'Focus Zone - Seu Companheiro Definitivo de Concentração',
    ogDescription: 'Ferramenta profissional com ruído branco e sons naturais para melhorar concentração e produtividade.',
    twitterTitle: 'Focus Zone - Ferramenta Concentração',
    twitterDescription: 'Ruído branco + Sons naturais + Frases inspiradoras = Experiência perfeita de concentração 🎯',
    lang: 'pt-BR',
    hreflang: 'pt',
    locale: 'pt_BR'
  },
  'ru-RU': {
    title: 'Focus Zone - Инструмент Концентрации | Белый Шум и Медитация',
    description: 'Профессиональный инструмент для улучшения концентрации с белым шумом, природными звуками и успокаивающими фонами. Повышайте продуктивность в работе и учёбе.',
    keywords: 'инструмент концентрации,белый шум,концентрация,продуктивность,фокус учёба,медитация,фокус работа,фоновые звуки,фоновая музыка,звуки природы,приложение концентрации,расслабление',
    ogTitle: 'Focus Zone - Ваш Идеальный Спутник Концентрации',
    ogDescription: 'Профессиональный инструмент с белым шумом и звуками природы для улучшения концентрации и продуктивности.',
    twitterTitle: 'Focus Zone - Инструмент Концентрации',
    twitterDescription: 'Белый шум + Звуки природы + Вдохновляющие цитаты = Идеальная концентрация 🎯',
    lang: 'ru-RU',
    hreflang: 'ru',
    locale: 'ru_RU'
  },
  'it-IT': {
    title: 'Focus Zone - Strumento di Concentrazione | Rumore Bianco e Meditazione',
    description: 'Strumento professionale per migliorare la concentrazione con rumore bianco, suoni naturali e sfondi rilassanti. Aumenta la produttività nel lavoro e nello studio.',
    keywords: 'strumento concentrazione,rumore bianco,concentrazione,produttività,focus studio,meditazione,focus lavoro,suoni ambiente,musica sottofondo,suoni natura,app concentrazione,rilassamento,lavoro profondo',
    ogTitle: 'Focus Zone - Il Tuo Compagno Definitivo per la Concentrazione',
    ogDescription: 'Strumento professionale con rumore bianco e suoni naturali per migliorare concentrazione e produttività.',
    twitterTitle: 'Focus Zone - Strumento Concentrazione',
    twitterDescription: 'Rumore bianco + Suoni naturali + Citazioni ispirative = Esperienza perfetta di concentrazione 🎯',
    lang: 'it-IT',
    hreflang: 'it',
    locale: 'it_IT'
  }
}

export function useSEO() {
  const updateSEOMeta = (language) => {
    const config = seoConfig[language] || seoConfig['en-US']
    
    // Update page title
    document.title = config.title
    
    // Update html lang attribute
    document.documentElement.lang = config.lang
    
    // Update meta description
    updateMetaTag('description', config.description)
    
    // Update meta keywords
    updateMetaTag('keywords', config.keywords)
    
    // Update meta language
    updateMetaTag('language', config.lang)
    
    // Update Open Graph meta tags
    updateMetaProperty('og:title', config.ogTitle)
    updateMetaProperty('og:description', config.ogDescription)
    updateMetaProperty('og:locale', config.locale)
    
    // Update Twitter Card meta tags
    updateMetaName('twitter:title', config.twitterTitle)
    updateMetaName('twitter:description', config.twitterDescription)
    
    // Update or add alternate language links
    updateHrefLangLinks()
  }
  
  const updateMetaTag = (name, content) => {
    let meta = document.querySelector(`meta[name="${name}"]`)
    if (!meta) {
      meta = document.createElement('meta')
      meta.name = name
      document.head.appendChild(meta)
    }
    meta.content = content
  }
  
  const updateMetaProperty = (property, content) => {
    let meta = document.querySelector(`meta[property="${property}"]`)
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('property', property)
      document.head.appendChild(meta)
    }
    meta.content = content
  }
  
  const updateMetaName = (name, content) => {
    let meta = document.querySelector(`meta[name="${name}"]`)
    if (!meta) {
      meta = document.createElement('meta')
      meta.name = name
      document.head.appendChild(meta)
    }
    meta.content = content
  }
  
  const updateHrefLangLinks = () => {
    // Remove existing hreflang links
    const existingLinks = document.querySelectorAll('link[hreflang]')
    existingLinks.forEach(link => link.remove())
    
    // Add new hreflang links
    Object.entries(seoConfig).forEach(([lang, config]) => {
      const link = document.createElement('link')
      link.rel = 'alternate'
      link.hreflang = config.hreflang
      link.href = `${window.location.origin}?lang=${lang}`
      document.head.appendChild(link)
    })
    
    // Add x-default hreflang
    const defaultLink = document.createElement('link')
    defaultLink.rel = 'alternate'
    defaultLink.hreflang = 'x-default'
    defaultLink.href = window.location.origin
    document.head.appendChild(defaultLink)
  }
  
  const addStructuredData = (language) => {
    const config = seoConfig[language] || seoConfig['en-US']
    
    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]')
    if (existingScript) {
      existingScript.remove()
    }
    
    // Add new structured data focused on productivity and concentration
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": config.title,
      "description": config.description,
      "url": window.location.origin,
      "applicationCategory": "ProductivityApplication",
      "operatingSystem": "Web",
      "inLanguage": config.hreflang,
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "author": {
        "@type": "Organization",
        "name": "Focus Zone"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Focus Zone"
      },
      "image": `${window.location.origin}/logo.png`,
      "screenshot": `${window.location.origin}/logo.png`,
      "softwareVersion": "1.0",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "ratingCount": "200"
      },
      "featureList": [
        "White noise generator",
        "Nature sounds",
        "Focus timer",
        "Meditation support",
        "Inspirational quotes",
        "Visual effects",
        "Multi-language support"
      ]
    }
    
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.textContent = JSON.stringify(structuredData, null, 2)
    document.head.appendChild(script)
  }
  
  return {
    updateSEOMeta,
    addStructuredData
  }
}